import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Home, BookOpen, Info, Calendar, ShoppingBag, FileText, Phone, Heart, Users, Shield, HelpCircle, Map } from 'lucide-react';
const sitemapLinks = [{
  category: 'Main Navigation',
  links: [{
    name: 'Home',
    path: '/',
    icon: Home
  }, {
    name: 'Programs',
    path: '/programs',
    icon: BookOpen
  }, {
    name: 'About Us',
    path: '/about',
    icon: Info
  }, {
    name: 'Events',
    path: '/events',
    icon: Calendar
  }, {
    name: 'Shop',
    path: '/shop',
    icon: ShoppingBag
  }, {
    name: 'Blog & Resources',
    path: '/blog',
    icon: FileText
  }, {
    name: 'Contact',
    path: '/contact',
    icon: Phone
  }]
}, {
  category: 'Get Involved',
  links: [{
    name: 'Donate',
    path: '/donate',
    icon: Heart
  }, {
    name: 'Volunteer',
    path: '/volunteer',
    icon: Users
  }]
}, {
  category: 'Legal & Support',
  links: [{
    name: 'Terms & Conditions',
    path: '/terms',
    icon: Shield
  }, {
    name: 'Privacy Policy',
    path: '/privacy',
    icon: Shield
  }, {
    name: 'FAQ',
    path: '/faq',
    icon: HelpCircle
  }, {
    name: 'Sitemap',
    path: '/sitemap',
    icon: Map
  }]
}];
export function Sitemap() {
  return <div className="pt-0 bg-warmwhite min-h-screen" data-id="element-1312" data-mp="213a44hljrd3g">
      {/* Hero Section */}
      <section className="relative pt-32 pb-16 bg-navy overflow-hidden" data-id="element-1313" data-mp="1x1os0ygu72ub">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" data-id="element-1314" data-mp="2tqwjen450665" />
        <div className="container relative z-10 mx-auto px-6 md:px-12 text-center" data-id="element-1315" data-mp="2orted2o5pzy6">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1316" data-mp="2k0urfk8ny3ly">
            <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-1317" data-mp="2fxyhehx6vftm">
              Sitemap
            </h1>
            <p className="text-lg text-white/80 max-w-2xl mx-auto" data-id="element-1318" data-mp="37r775ha5h4n3">
              A complete overview of the Poch Global website structure.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 lg:py-16" data-id="element-1319" data-mp="1argj0jph3pxt">
        <div className="container mx-auto px-6 md:px-12 max-w-5xl" data-id="element-1320" data-mp="1aucfe3loa6k5">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-1321" data-mp="w32fe6k8fxg7">
            {sitemapLinks.map((section, idx) => <div key={idx} className="bg-white p-8 rounded-3xl shadow-sm border border-softgray" data-id="element-1322" data-mp="110lraztgjy4z" data-mpi={idx}>
                <h2 className="text-xl font-bold text-navy mb-6 pb-4 border-b border-softgray" data-id="element-1323" data-mp="n508jadtial0">
                  {section.category}
                </h2>
                <ul className="space-y-4" data-id="element-1324" data-mp="d5svkoazwhyf">
                  {section.links.map((link, i) => <li key={i} data-id="element-1325" data-mp="i4vpbcliz1r3" data-mpi={i}>
                      <Link to={link.path} className="flex items-center gap-3 text-mediumgray hover:text-gold transition-colors group" data-id="element-1326" data-mp="i42pywowbeiz">
                        <link.icon className="w-5 h-5 text-navy/40 group-hover:text-gold transition-colors" data-id="element-1327" data-mp="2cfr795ilnt6j" />
                        <span className="font-medium" data-id="element-1328" data-mp="s5js8petbv7">{link.name}</span>
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}